import template from './dataBrowser.html';
import controller from './dataBrowser.controller';
import metaData from '../../models/metaData.js';

let databrowserComponent = () => {
  return {
    restrict: 'E',
    bindings: {},
    template,
    controller,
    controllerAs: 'vm',
    link: ($scope, $elem, $attrs, entitler) => {
      setDefaults($scope, entitler);
    }
  };
};

function setDefaults($scope, entitler) {
  $scope.vm.metaData = {};
  angular.copy(metaData, $scope.vm.metaData);
  $scope.vm.entitler = entitler;
  $scope.vm.metaData.entitler.dataSet = entitler;
}

export default databrowserComponent;


// WEBPACK FOOTER //
// ./app/components/dataBrowser/dataBrowser.component.js